import { api } from './api';

export async function getVirtualGoods() {
  try {
    const { data } = await api.get('virtualgoods/item?player=me&orderby=extra.order&reverse=false');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getExperienceCatalog() {
  try {
    const { data } = await api.get('database/experiencias__c');
    return data;
  } catch (error) {
    return error;
  }
}

export async function getVirtualGood(_id: string) {
  try {
    const { data } = await api.get(`virtualgoods/item/${_id}`);
    return data;
  } catch (error) {
    return error;
  }
}

export async function getCatalogItems(_id: string) {
  try {
    const { data } = await api.get(`virtualgoods/item?catalog=${_id}`);
    return data;
  } catch (error) {
    return error;
  }
}

export async function purchaseItem(item: string, player: string) {
  try {
    const { data } = await api.post('virtualgoods/purchase', {
      item,
      player,
    });
    return data;
  } catch (error) {
    return error;
  }
}

export async function getCatalog() {
  const { data } = await api.post('find/get_catalog', {});
  return data[0];
}

export async function saveAddress(payload: any) {
  try {
    const { data } = await api.put('database/address__c', payload);
    return data;
  } catch (error) {
    return error;
  }
}

export async function getAddress() {
  try {
    const { data } = await api.post('find/get_address', {});
    return data;
  } catch (error) {
    return error;
  }
}
